export enum IconType {
  arrow_down = 'arrow_down',
  arrow_right = 'arrow_right',
  arrow_right_short = 'arrow_right_short',
  arrow_right_skew = 'arrow_right_skew',
  arrow_left = 'arrow_left',
  arrow_right_white = 'arrow_right_white',
  industry_banking_icon = 'industry_banking_icon',
  industry_healthcare_icon = 'industry_healthcare_icon',
  industry_logistics_icon = 'industry_logistics_icon',
  checkmark = 'checkmark',
  close = 'close',
  navigation = 'navigation',
  chevron_down = 'chevron_down',
  facebook = 'facebook',
  x_twitter = 'x_twitter',
  linkedin = 'linkedin',
  link = 'link',
  search = 'search',
  verified = 'verified',
  academy_bullet_point = 'bullet_point',
  academy_bullet_point_small = 'bullet_point_small',
  academy_bullet_point_very_small = 'bullet_point_very_small',
}
